/*
*  All text on the site, word for word from the Wix site (thecharlesgreiggallery.co.za).
*  Artworks (products) are in artworks.js.
*/

export const SITE_NAME = "The Charles Greig Gallery";
export const SITE_URL = "https://www.thecharlesgreiggallery.co.za";
export const DEFAULT_DESCRIPTION = "The Charles Greig Gallery at Hyde Park Corner, Johannesburg - bronze wildlife sculpture by Donald Greig, Italia Greig, Jackie Noakes, David Tomlinson and more, and Ardmore ceramic art.";

//URLs are the same as on Wix, so old links and Google results keep working
export const ROUTES = {
  HOME: "/",
  ABOUT: "/contact", //Wix's About page lives at /contact
  ARDMORE: "/ardmore",
  BIRDLIFE: "/birdlifesouthafrica",
  ALL_ARTWORKS: "/category/all-products",
  CATEGORY: "/category/:slug",
  ARTWORK: "/product-page/:slug",
};

export const artworkPath = (slug) => `/product-page/${slug}`;
export const categoryPath = (slug) => `/category/${slug}`;

export const CONTACT_DETAILS = {
  ADDRESS: ["Hyde Park Corner", "6th Road, Hyde Park", "Johannesburg, 2196"],
  MAP_LINK: "https://www.google.com/maps/search/?api=1&query=The+Charles+Greig+Gallery+Hyde+Park+Corner+Johannesburg",
  CONTACT_NAME: "Rayno Bezuidenhout | Head Gallerist",
  EMAIL: "rayno@charlesgreig.co.za",
  PHONE: { label: "+27 73 706 6160", link: "tel:+27737066160" },
  //Wix linked wa.me/0737066160, which WhatsApp doesn't recognise - it needs the international number
  WHATSAPP_LINK: "https://wa.me/27737066160",
  FACEBOOK_LINK: "https://www.facebook.com/TheCharlesGreigGallery/",
  INSTAGRAM_LINK: "https://www.instagram.com/charlesgreiggallery/",
  CREDIT: { label: "TapX", link: "https://www.tap-x.com/" },
};

/*
*  Artists. slug = the artist's key (used in artworks.js), path = their Wix page, category = their Wix shop category URL.
*  group: "artists" / "new" = the Artists / New Artists menus on Wix.
*/
export const ARTISTS = [
  {
    slug: "donald-greig",
    name: "Donald Greig",
    title: "DONALD GREIG",
    group: "artists",
    path: "/artist-donald-greig",
    category: "donald-greig",
    photo: "/images/artists/donald-greig.webp",
    card: "/images/artists/donald-greig-card.webp",
    bio: [
      "Donald Greig, a qualified gemmologist and jewellery designer by trade, is based at the Waterfront store in Cape Town. Donald studied sculpture at the Lorenzo de Medici school of Art in Florence. It was here, that the naturally gifted sculptor learned the age old process of bronze casting. His love for the African bush and wildlife inspires his sculpture and provides endless subject matter. From small dung beetles to life-size buffalo and rhinoceros. Donald’s work encompasses a large range of animals, both in species and scale. The growing demand for his work keeps this prolific sculptor and his impressive foundry very busy, and he has had many international commissions, including creating a caravan of life-size camels for a shopping mall in Dubai!",
    ],
  },
  {
    slug: "italia-greig",
    name: "Italia Greig",
    title: "ITALIA GREIG",
    group: "artists",
    path: "/artist-italia-greig",
    category: "italia-greig",
    photo: "/images/artists/italia-greig.webp",
    card: "/images/artists/italia-greig-card.webp",
    bio: [
      "Italia Greig, the matriarch of the family, has always had a fascination for the natural world. Spending memorable times with her father, a keen mountaineer and naturalist, on Table Mountain, she learnt about such creatures as Trapdoor Spiders, Ant Lions and Black Eagles. Her joy of life, and passion for things living, informs her attention to detail in her sculpture. In her works there is a strong interest in birds, and she will often create an interactive group in various poses. The patina on an Italia Greig piece is of special note, in that she uses various techniques of verdigris, weathering and often very light colours to stunning effect. She prefers to sculpt in life-size scale and has created among others, giant Galapagos Tortoises, Crowned Cranes, Goliath Herons and much admired Pelicans in various poses. We have chosen her Great White Pelican as the Gallery’s logo.",
    ],
  },
  {
    slug: "jackie-noakes",
    name: "Jackie Noakes",
    title: "JACKIE NOAKES",
    group: "artists",
    path: "/artist-jackie-noakes",
    category: "jackie-noakes",
    photo: "/images/artists/jackie-noakes.webp",
    card: "/images/artists/jackie-noakes-card.webp",
    bio: [
      "Born in Nottingham, England, Jackie settled with her parents in Africa at the age of fifteen. She spent her teenage years in Zambia where she began to sculpt with clay she dug from the river beds. During those early days, Jackie was often on horseback exploring the surrounding areas, developing a love for the African Bushveld. Later as a newly-wed couple, she and her husband lived adjacent to the Kafue National Park where a great deal of her time was spent studying the animals which roamed in this wilderness.",
      "After that time, with three small children, they lived on the banks of the Kafue River where their closest neighbours were families of Hippopotamus.",
      "Today South Africa is home for Jackie and her family. Her finely executed sculpture has been successfully exhibited in galleries throughout the world.",
    ],
  },
  {
    slug: "david-tomlinson",
    name: "David Tomlinson",
    title: "DAVID TOMLINSON",
    group: "artists",
    path: "/artist-david-tomlinson",
    category: "dave-tomlinson",
    photo: "/images/artists/david-tomlinson.webp",
    card: "/images/artists/david-tomlinson-card.webp",
    bio: [
      "Left the world of advertising several decades ago to revive his creative spirit and integrity. He had always loved the three dimensional art form, and. with the encouragement of his mentor, Everard Read, found his expression in sculpture. A passion for the bush and wide open spaces and the creatures that inhabit it, inspired his choice of subject matter.",
      "Observing animals acutely and in intense detail, David creates pieces that capture each subject with great realism and charm. His miniature pack of Wild Dogs has been praised by game rangers as perfectly observed and captured. His bird sculptures, while being “ornithologically correct” are also greatly appreciated for their beauty. Over the years his sculptures have found their way into homes, businesses and institutions throughout the world and he has had a number of successful exhibitions in South Africa and abroad.",
      "In his own words, “I am fascinated by the thought that I am able to create sculpture that can give my clients feelings of peace, joy and happiness when remembering the stunning cameos of their own experiences in the bush.”",
    ],
  },
  {
    slug: "steven-john-wilkins",
    name: "Steven John Wilkins",
    title: "Steven John Wilkins",
    group: "artists",
    path: "/artist-steven-john-wilkens",
    category: "steve-john-wilkins",
    photo: "/images/artists/steven-john-wilkins.webp",
    card: "/images/artists/steven-john-wilkins-card.webp",
    bio: [
      "Steven John Wilkins was born in Johannesburg in 1987.\nHe sculpts in wax, casts in bronze, and sometimes works in other media.\nSteven has been represented by the Charles Greig Gallery since 2018.",
    ],
  },
  {
    slug: "malcolm-solomon",
    name: "Malcolm Solomon",
    title: "MALCOLM SOLOMON",
    group: "artists",
    path: "/artist-malcolm-solomon",
    category: "malcolm-solomon",
    photo: "/images/artists/malcolm-solomon.webp",
    card: "/images/artists/malcolm-solomon-card.webp",
    bio: [
      "Malcolm “Salty” Solomon is a man of the sea, and his love of all Nature extends to the creatures that inhabit it.",
      "Having worked in many different media – stone and wood carving, murals, and paint in various forms, he discovered bronze casting in 2002. From that time he began to produce sculpture in a variety of styles, and his popularity grew. As part of our gallery’s theme of Natural History, some of Malcolm’s striking pieces are his Diving Greenbacked Turtles, Giant Ghost Crabs, and Kingfishers in the Reeds.",
    ],
  },
  {
    slug: "chris-bladen",
    name: "Chris Bladen",
    title: "CHRIS BLADEN",
    group: "new",
    path: "/chris-bladen",
    category: "chris-bladen",
    photo: "/images/artists/chris-bladen-card.webp",
    card: "/images/artists/chris-bladen-card.webp",
    bio: [
      "Chris, an avid fly-fisherman and birder, has honed his meticulous eye for detail through close encounters with fish and birds. Growing up with a deep appreciation for nature, he began carving fish in his teens. After a career in dental technology, Chris transitioned seamlessly into creating highly detailed bronze wildlife sculptures.",
      "Each piece starts with an in-depth study of form and environment, and he uses various clay mediums, including locally sourced riverbank clay. Chris's work aims to inspire an appreciation for marine and bird life, blending true-to-life representation with abstract elements. His sculptures not only capture the essence of the natural world but also evoke a profound sense of connection and conservation, urging viewers to cherish and protect these vital ecosystems.",
    ],
  },
  {
    slug: "robert-leggat",
    name: "Robert Leggat",
    title: "ROBERT LEGGAT",
    group: "new",
    path: "/artist-robert-leggat",
    category: "robert-legget",
    photo: "/images/artists/robert-leggat.webp",
    card: "/images/artists/robert-leggat-card.webp",
    bio: [
      "Studied Fine Art at Cape Technicon, majoring in sculpture, and completing his final year at the Pretoria Technicon in 1988.",
      "He is passionate about the environment and protecting the places and creatures from which he draws his creative inspiration.",
      "The attention to detail in his pieces is the result of meticulous observation, sketching and drawing of the live and three-dimensional form. He lives and breathes bronze sculpture and utilises his own foundry for casting with a hands-on approach to every step of the process. A versatile artist, his pieces are sought after by collectors worldwide. He also receives many commissions, privately and from the corporate sector. Among his recent bird sculptures, is a gliding Wandering Albatross and a life-size Fish Eagle on a branch that functions as a water feature.",
    ],
  },
  {
    slug: "brendan-leggat",
    name: "Brendan Leggat",
    title: "Brendan Leggat",
    group: "new",
    path: "/brendan-leggat",
    category: "brendan-leggat",
    photo: "/images/artists/brendan-leggat.webp",
    card: "/images/artists/brendan-leggat.webp",
    bio: [
      "Brendan Leggat is a South African sculptor working primarily in bronze. Having begun exhibiting at a young age, his practice is shaped by careful observation and an enduring attentiveness to the familiar.",
      "Working predominantly with domestic animals, Leggat’s sculptures dwell in the small, telling moments — a tilt of the head, a pause in movement, a suggestion of temperament that feels at once known and gently reimagined. There is a lightness of touch in the work, where nuance and emotion take precedence, and where character reveals itself without insistence. His bronzes are further distinguished by a signature handling of texture, form, and patination, lending each piece a recognisable and individual presence.",
      "Each work carries a quiet singularity, offering not only an object, but a presence — something to be lived with, returned to, and gradually known. As his body of work continues to evolve, Leggat’s sculptures are increasingly recognised for their enduring appeal, finding their place within considered collections both locally and abroad.",
    ],
  },
  {
    slug: "dawid-oosthuizen",
    name: "Dawid Oosthuizen",
    title: "Dawid Oosthuizen",
    group: "new",
    path: "/dawid-oosthuizen",
    category: "dawid-oosthuizen",
    photo: "/images/artists/dawid-oosthuizen.webp",
    card: "/images/artists/dawid-oosthuizen.webp",
    bio: [
      "Dawid Oosthuizen, Born 29 July 1986 in Welkom South Africa.",
      "I have always had a fascination when it comes to the art of sculpting from Japanese to African forms of art.",
      "With the opportunity joining the Charles Greig company I was more exposed to the art of bronze sculpting and therefore I have been very involved in the process myself which led me to a bigger passion for the industry.",
      "I am self-taught with a background in jewellery manufacturing that also has a similar attribute.",
      "Even though I have only been doing this for a year full time, I have had the opportunity to display my art in The Charles Greig Gallery.",
      "Even though this is a dying art form I am hoping I can inspire younger generations with my work so that we have more youth looking to get into this industry.",
    ],
  },
];

//Ardmore is a shop category too, but has its own page (not an artist page)
export const ARDMORE_CATEGORY = { slug: "ardmore", name: "Ardmore", category: "ardmore" };

//"Shop By Artist" strip on the home page (same order as Wix; Brendan Leggat & Dawid Oosthuizen added at the end)
export const HOME_ARTIST_ORDER = [
  "donald-greig", "malcolm-solomon", "jackie-noakes", "david-tomlinson", "italia-greig",
  "robert-leggat", "steven-john-wilkins", "chris-bladen", "brendan-leggat", "dawid-oosthuizen",
];

export const NAV_LINKS = [
  { label: "Home", path: ROUTES.HOME },
  { label: "About", path: ROUTES.ABOUT },
  { label: "Artists", group: "artists" },
  { label: "New Artists", group: "new" },
  { label: "Ardmore Ceramics", path: ROUTES.ARDMORE },
  { label: "Browse Art / Bronzes", path: ROUTES.ALL_ARTWORKS },
  { label: "BirdLife South Africa", path: ROUTES.BIRDLIFE },
];

const ABOUT_START = [
  "Charles Greig, the Aberdeen clockmaker, first opened his doors on the dusty streets of Johannesburg in 1899. His name became a brand that, more than a century later, is a leader in the luxury goods market, and internationally recognized as a purveyor of handcrafted jewellery and fine timepieces.",
  "Today, his great-grandson Christopher Greig, whilst continuing that tradition, is also a designer and artist – as can be seen by his many commissioned works of jewellery, beautifully sketched and finely executed. His love of art and Nature has always been evident in the bronze sculpture displayed in the elegant Hyde Park store. It can be said that nature and beautiful things are an abiding passion of the Greigs, and two family members have emerged as talented sculptors of wildlife- Christopher’s mother, Italia and brother, Donald.",
];

export const HOME = {
  HERO_TITLE: "THE CHARLES GREIG GALLERY",
  //Slideshow behind the title (crossfades, as on Wix). Each photo has a 2880px version and a 1440px one for smaller screens
  HERO_SLIDES: [
    { src: "/images/home/hero.webp", small: "/images/home/hero-1440.webp", alt: "The Charles Greig Gallery shop front at Hyde Park Corner, with bronze sculptures behind the glass doors" },
    { src: "/images/home/hero-2.webp", small: "/images/home/hero-2-1440.webp", alt: "Bronze birds and sculptures on plinths inside the gallery" },
    { src: "/images/home/hero-3.webp", small: "/images/home/hero-3-1440.webp", alt: "Bronze lion and otter sculptures in the gallery" },
  ],
  HERO_SLIDE_MS: 4500, //Time each photo shows
  LATEST_TITLE: "Latest Artworks",
  LATEST_COUNT: 24, //Number of newest artworks in the slider (24 on Wix)
  ABOUT_TITLE: "About",
  ABOUT: ABOUT_START,
  ABOUT_IMAGES: [
    { src: "/images/home/about-otters.webp", alt: "Bronze sculpture of two Cape clawless otters" },
    { src: "/images/home/about-dung-beetle.webp", alt: "Bronze dung beetle sculpture with its ball" },
  ],
  VIDEO: {
    SRC: "/images/home/gallery-tour.mp4",
    POSTER: "/images/home/gallery-tour-poster.webp",
    TITLE: "A tour of The Charles Greig Gallery, Hyde Park Corner",
  },
  SHOP_BUTTON: "SHOP ALL ARTWORKS",
  ARTISTS_TITLE: "Shop By Artist",
};

export const ABOUT = {
  PAGE_TITLE: "About",
  TITLE: "Where it Started",
  INTRO: ABOUT_START,
  SECTIONS: [
    {
      text: "In addition to the sculpture, Christopher has had a long-standing relationship with the Ardmore ceramic art studio, hosting several specially commissioned and themed exhibitions, including The Great Cats of the World, Just So Crocodiles and Other Curiosities, and the recent Parrots and Pomegranates. The support, encouragement and admiration he has shown for this local phenomenon under the banner of Charles Greig has played an important role in developing the works of Ardmore into modern day collectables.",
      image: { src: "/images/about/ardmore-pelicans.webp", alt: "Ardmore ceramic bowl decorated with white pelicans" },
    },
    {
      text: "In 2014, he saw the need to expand and provide a separate space to showcase his growing enthusiasm for bronze sculpture and Ardmore ceramic art. Christopher created the Charles Greig Gallery in the Hyde Park Corner shopping centre, downstairs from the flagship store. Contemporary in design, and facilitating easy viewing of the artworks, the glass doors fold back to reveal an open yet intimate ambience that invites informal browsing.",
      image: { src: "/images/about/ceramic-eagle.webp", alt: "Detail of a white ceramic eagle sculpture" },
    },
  ],
};

export const ARDMORE = {
  PAGE_TITLE: "Ceramics",
  LOGO: "/images/ardmore/ardmore-logo.webp",
  PHOTO: { src: "/images/ardmore/christopher-greig.webp", alt: "Christopher Greig with an Ardmore ceramic urn" },
  TEXT: [
    "Ardmore Ceramics is a renowned South African art studio that specializes in creating intricate and captivating ceramic sculptures. Founded in 1985 by Fée Halsted, the studio is located in the KwaZulu-Natal region of South Africa. What sets Ardmore apart is its unique approach to ceramics, which combines traditional African artistry with contemporary design.",
    "Ardmore Ceramics has gained international recognition for its distinctive style, which includes the use of vibrant and bold colors, intricate detailing, and a sense of whimsy that captures the spirit of Africa. These pieces are highly collectible and have been exhibited in galleries and museums worldwide.",
    //Wix continues: "Since my last knowledge update in September 2021, Ardmore Ceramics may have continued to produce new and
    //exciting works, so I recommend visiting their official website or checking out recent news articles to learn more about
    //their latest creations and developments." - left off (reads as an AI chatbot answer); TBC with the client
    "The studio also provides employment opportunities and training to local artists, helping to preserve and promote the rich artistic heritage of South Africa.",
  ],
  ARTWORKS_TITLE: "Artworks",
  CATALOGUE_TITLE: "Zebra Drawn Chariots and other Striped Curiosities",
  //Exhibition catalogue pages (the slideshow on Wix)
  CATALOGUE: Array.from({ length: 25 }, (_, i) => `/images/ardmore/catalogue-${String(i + 1).padStart(2, "0")}.webp`),
  YOUTUBE_ID: "k34KmmuFkfI",
};

export const BIRDLIFE = {
  PAGE_TITLE: "BirdLife South Africa",
  ABOUT_TITLE: "About BirdLife South Africa",
  ABOUT: "BirdLife South Africa strives to conserve birds, their habitats, and biodiversity through scientifically based programmes, through supporting the sustainable and equitable use of natural resources and by encouraging people to enjoy and value nature.",
  ATF_TITLE: "Albatross Task Force",
  ATF: "The internationally lauded Albatross Task Force works to conserve and protect at least 24 albatross and petrel species. Through the uptake of bord-scaring lines, it has achieved a reduction of seabird deaths by 90% in the South African offshore trawl fishery.",
  YOUTUBE_ID: "rBljILmQakE",
  YOUTUBE_TITLE: "Albatross Task Force South Africa",
  TEAM_IMAGE: { src: "/images/birdlife/atf-team.webp", alt: "Andrea Angel and Reason Nyengera of the Albatross Task Force", caption: "ATF team, Andrea Angel and Reason Nyengera OTTO WHITEHEAD" },
  GOALS_TITLE: "ATF Goals",
  GOALS_INTRO: "The ATF team, which is led by manager Andrea Angel and project manager Reason Nyengera, aims to:",
  GOALS: [
    "Improve the conservation status of albatross and petrel species that forage in the oceans around South Africa.",
    "Ensure seabird bycatch mitigation measures are used by all relevant fishing fleets in South Africa and support the implmentation of these measures in the Southern Ocean.",
    "Make certain that compliance with seabird management measures and monitoring procedures are effected across relevant fisheries and form part of national legistlation.",
  ],
  SUPPORT: "Proudly supported by The Charles Greig Gallery",
  ALBATROSS_IMAGE: { src: "/images/birdlife/yellow-nosed-albatross.webp", alt: "Indian yellow-nosed albatross taking off from the sea", caption: "Indian yellow-nosed Albatross MARTIN POTGIETER" },
};

export const SHOP = {
  ALL_TITLE: "All Products",
  BROWSE_TITLE: "Browse by",
  //Same photo as the third home page slide
  BANNER: { src: "/images/home/hero-3.webp", small: "/images/home/hero-3-1440.webp" },
  PAGE_SIZE: 24, //Artworks shown before "Load More" (as on Wix)
};

export const CONTACT_FORM = {
  TITLE: "Contact Us",
  ARTIST_LABEL: "Choose an Artist",
  MESSAGE_LABEL: "Sculpture Enquiry",
  MESSAGE_PLACEHOLDER: "Sculpture's name - Enquiry",
};
